/**
 * The trial link offered by the public demo.
 *
 * The demo is the page we put in a message, so the link that brought someone
 * here is the only thing that says which message worked. The demo used to
 * hardcode `source=demo_publica_es`, which made every registration look alike:
 * a reply to a cohort message and a visitor who found the page on their own
 * were indistinguishable once they signed up.
 *
 * Whatever attribution the visitor arrived with wins; the demo's own values
 * fill what the link did not carry. These reach the backend as the account's
 * first-touch attribution, so a registration stays countable to its channel.
 *
 * Kept free of React imports on purpose: the page itself pulls in the router,
 * which this project's test runner cannot resolve.
 */

/** What the demo claims when the visitor carried nothing of their own. */
export const TRIAL_HREF_PARAMS =
    'source=demo_publica_es&utm_source=playground&utm_medium=demo&utm_campaign=demo_publica_es';

const CARRIED = ['source', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export const buildTrialHref = (search, language) => {
    const incoming = new URLSearchParams(search || '');
    const params = new URLSearchParams(TRIAL_HREF_PARAMS);
    for (const key of CARRIED) {
        const value = incoming.get(key);
        if (value) params.set(key, value);
    }
    // The language of the page the visitor is reading, not of the link they
    // clicked: someone who switched to Spanish here should not meet an English
    // form because the message said `lang=en`.
    params.set('lang', language);
    return `/register?${params.toString()}`;
};
